import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "report" }

import UserList from '@/components/users/UserList.vue';
import UsersPagination from '@/components/users/UsersPagination.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CognitoUserList',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UsersPagination),
    _createVNode(UserList)
  ]))
}
}

})